import {
  addDoc,
  collection,
  doc,
  getDocs,
  orderBy,
  query,
  serverTimestamp,
  setDoc,
  Timestamp,
} from "firebase/firestore";
import { useState, useEffect } from "react";
import { MdSend } from "react-icons/md";
import { LazyLoadImage } from "react-lazy-load-image-component";
import { Link, useLocation } from "react-router-dom";
import { useCollectionQuery } from "../../../hooks/useCollectionQuery";
import { db } from "../../../shared/firebase";
import { useAppSelector } from "../../../store/hooks";
import SelectBox from "../../Common/SelectBox";
import CommentUserData from "./CommentUserData";

const Comment = ({ id, media_type }) => {
  const currentUser = useAppSelector((state) => state.auth.user);
  const location = useLocation();

  const [commentInputValue, setCommentInputValue] = useState("");
  const [isSendingComment, setIsSendingComment] = useState(false);
  const [commentLimit, setCommentLimit] = useState(5);
  const [commentSortType, setCommentSortType] = useState("latest");

  const options = [
    { value: "latest", label: "Latest" },
    { value: "popular", label: "Popular" },
  ];

  const commentSubmitHandler = (e) => {
    e.preventDefault();

    if (!commentInputValue) return;

    setIsSendingComment(true);
    addDoc(collection(db, `${media_type}-${id}`), {
      user: currentUser,
      value: commentInputValue.trim().slice(0, 500),
      reactions: {},
      createdAt: serverTimestamp(),
      isEdited: false,
    }).finally(() => setIsSendingComment(false));

    setCommentInputValue("");
  };

  const {
    data: commentData,
    isLoading,
    isError,
  } = useCollectionQuery(
    id,
    query(collection(db, `${media_type}-${id}`), orderBy("createdAt", "desc"))
  );

  // Auto comment by admin
  useEffect(() => {
    if (!media_type || !id) return;

    const dummyUserID1 = "RO6eEaJPPiORTF9PWS0Yh7HswLn2";
    getDocs(collection(db, `${media_type}-${id}`)).then((docSnapshot) => {
      if (
        !docSnapshot.docs.some((doc) => doc.data()?.user.uid === dummyUserID1)
      ) {
        const dummyUserID2 = "mtDrEP3x51UBgHzkzeJFtGYv0tX2";
        const dummyUserID3 = "jCSwJtPNknQFLT4sNytZ6g8xudi2";
        const sampleReactions = {};
        sampleReactions[dummyUserID2] = "haha";
        sampleReactions[dummyUserID3] = "love";

        setDoc(doc(db, `${media_type}-${id}`, "admin"), {
          user: {
            displayName: "Shwet Khatri",
            email: "shwetkhatri2001@gmail.com",
            emailVerified: true,
            photoURL: "https://cutt.ly/I82aZ4j",
            uid: dummyUserID1,
          },
          value: `Wow, this ${media_type} completely swept me away! The storyline was so captivating and the characters were so well-developed that I felt like I was right there with them. I laughed, I cried, and I couldn't look away - this movie has everything you could want and more! I can't wait to recommend it to all my friends, no matter what their favorite genre is.`,
          reactions: sampleReactions,
          createdAt: Timestamp.fromDate(new Date("March 4, 2023 12:00:00")),
          isEdited: false,
        });
      }
    });
  }, [media_type, id]);

  return (
    <div className="mb-16">
      <div className="flex items-center justify-between mb-6">
        <div className="relative w-[140px]">
          <p className="md:text-2xl text-xl text-white font-medium">Comments</p>
          {commentData && commentData.size > 0 && (
            <p className="absolute md:-top-2 md:-right-5 -top-3 right-2 bg-dark-lighten w-6 h-6 text-sm rounded-full flex justify-center items-center">
              {commentData.size}
            </p>
          )}
        </div>
        <div className="flex">
          <SelectBox
            options={options}
            defaultValue={options.find(
              (option) => option.value === commentSortType
            )}
            onChange={(e) => setCommentSortType(e?.value)}
            type="dark"
          />
        </div>
      </div>

      <div className="md:px-4 px-1">
        <div className="mb-12">
          {!currentUser && (
            <p className="text-lg text-center">
              You need to
              <Link
                to={`/auth?redirect=${encodeURIComponent(location.pathname)}`}
                className="text-primary font-medium"
              >
                {" login "}
              </Link>
              to comment.
            </p>
          )}
          {currentUser && (
            <form
              onSubmit={commentSubmitHandler}
              className="flex gap-4 items-center"
            >
              <LazyLoadImage
                src={currentUser.photoURL}
                alt=""
                effect="opacity"
                className="w-12 h-12 rounded-full object-cover shrink-0"
                referrerPolicy="no-referrer"
              />
              <input
                value={commentInputValue}
                onChange={(e) => setCommentInputValue(e.target.value)}
                type="text"
                className="py-3 flex-1 bg-dark-lighten outline-none rounded-full px-4 text-white"
                placeholder="Write comment..."
              />
              {isSendingComment ? (
                <div className="w-10 h-10 rounded-full border-[3px] border-t-transparent border-white animate-spin"></div>
              ) : (
                <button>
                  <MdSend size={30} className="text-white " />
                </button>
              )}
            </form>
          )}
        </div>

        <CommentUserData
          isLoading={isLoading}
          isError={isError}
          sortType={commentSortType}
          commentData={commentData}
          commentLimit={commentLimit}
          media_type={media_type}
          id={id}
          role="comment"
        />
      </div>

      {commentData && commentData.size > commentLimit && (
        <button
          className="font-medium"
          onClick={() => setCommentLimit((prev) => prev + 5)}
        >
          Load more comments ({commentLimit}/{commentData.size})
        </button>
      )}
    </div>
  );
};

export default Comment;
